var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGmx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1640,
    height: 472,
    viewBox: "0 0 1640 472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-GMX_LIGHT"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1640,
    height: 472
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GMX_LIGHT",
    "data-name": "GMX LIGHT",
    clipPath: "url(#clip-GMX_LIGHT)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO_GMX",
    "data-name": "LOGO GMX",
    transform: "translate(1.317 -16.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BASE",
    width: 1640,
    height: 472,
    transform: "translate(-1.317 16.974)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M1070.463,1104.6,798.486,696,525.667,1104.6H905.756L798.486,948.649l-53.212,81.022H688.683l109.8-162.915L957.28,1104.6Z",
    transform: "translate(-494.667 -647.027)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M151.659,143.338c-3.171,0-4.53,1.359-4.53,4.53v27.183c0,3.171,1.359,4.53,4.53,4.53h90.156v47.57c-17.669,28.995-49.382,45.758-91.515,45.758-67.5,0-109.184-43.492-109.184-126.853C41.116,63.149,90.045,19.2,145.77,19.2c43.492,0,78.83,17.216,90.156,58.9.906,3.171,2.718,4.53,5.437,4.53h29c3.171,0,4.983-1.359,4.983-4.53-12.232-63.426-66.6-95.14-129.571-95.14-70.675,0-144.522,54.366-144.522,163.1,0,107.372,69.769,163.1,150.864,163.1,49.382,0,94.234-20.387,123.229-65.239,3.171-4.53,4.53-10.42,4.53-17.216v-78.83c0-3.171-1.359-4.53-4.53-4.53ZM621.922-7.979c0-3.171-1.359-4.53-4.531-4.53H574.352c-3.624,0-5.89,1.359-7.249,4.53L479.212,193.627,391.321-7.979c-1.359-3.171-3.624-4.53-7.249-4.53H341.033c-3.171,0-4.53,1.359-4.53,4.53V300.092c0,3.171,1.359,4.53,4.53,4.53h28.995c3.171,0,4.53-1.359,4.53-4.53V46.84l88.8,200.7c1.359,2.718,3.171,4.077,5.89,4.077h19.934c2.718,0,4.53-1.359,5.89-4.077l88.8-200.7V300.092c0,3.171,1.359,4.53,4.53,4.53h28.995c3.171,0,4.531-1.359,4.531-4.53Zm98.764,0c-3.171-4.077-3.171-4.53-6.343-4.53H679.458c-3.171,0-4.53,2.265-3.171,4.53l96.046,145.428L664.508,300.092c-1.359,2.265,0,4.53,3.171,4.53h33.978c3.171,0,4.077-.453,7.249-4.53l86.079-129.571,86.079,129.571c3.171,4.077,4.077,4.53,7.249,4.53h33.978c3.171,0,4.531-2.265,3.171-4.53L817.638,137.449,913.683-7.979c1.359-2.265,0-4.53-3.171-4.53H875.628c-3.171,0-3.171.453-6.343,4.53l-74.3,111.9Z",
    transform: "translate(676.695 107.216)",
    fill: "current"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGmx);
export default __webpack_public_path__ + "static/media/logo-gmx.e14662060089c98f996195c2b92f2231.svg";
export { ForwardRef as ReactComponent };